import { InstaPromoModel } from './insta-promo.model';

export class StoryModel {
    sharedList: any;
    storyDisplayInterval: number;
    storyIconShape: string;
    versionedList: any;
    instaPromoList: InstaPromoModel[];
}
